import {Component, OnInit} from '@angular/core';
import {PaymentMethod} from "../../user/payment-method";
import {Payment} from "../../user/payment";
import {ActivatedRoute} from '@angular/router';
import {FormControl} from '@angular/forms';
import {DialogService} from "../../../ng2-bootstrap-modal/dialog.service";
import {AddPaymentMethodComponent} from "./add-payment-method/add-payment-method.component";
import {SearchByPropertyPipe} from "../../shared/pipes/search-by-property.pipe";
import {Utils} from "../../shared/utils/utils";
import {Product} from "../../websites/website/product";
import {UserSubscription, UserSubscriptionType} from "../../user/user-subscription";
import {RemovePaymentMethodComponent} from "./remove-payment-method/remove-payment-method.component";
import {ChangePaymentMethodComponent} from "./change-payment-method/change-payment-method.component";
import {UserSubscriptionStatus} from "../../user/user-subscription-status";
import {RequesterService} from "../../shared/services/requester/requester.service";
import {Store} from "@ngrx/store";
import * as fromStore from "../../store";
import {filter, first, switchMap} from "rxjs/operators";
import {WorkspaceService} from "../workspace.service";
import {TypeUtils} from "../../shared/utils/type-utils";
import {IDropdownListItem} from "../../shared/components/dropdown-list/dropdown-list-item";
import {DbResponse} from "../../shared/interceptors/db-response";
import {Config} from "../../config/config";
import {NotifierComponent} from "../../shared/components/notifier/notifier.component";
import {Notification} from "../../shared/components/notifier/notification";
import {NotificationType} from "../../shared/components/notifier/notification-type";
import {LanguageService} from "../../shared/services/language/language.service";
import {TextUtils} from "../../shared/utils/text-utils";

@Component({
    selector: 'db-billing',
    templateUrl: './billing.component.html',
    styleUrls: ['./billing.component.scss'],
    standalone: false
})
export class BillingComponent implements OnInit {

  public loading: boolean;
  public loadingStripe: boolean;
  public checkoutElement: any;

  public sortBy: FormControl;
  public sortDirection: FormControl;
  public userSubscription: UserSubscription;
  public UserSubscriptionType: any = UserSubscriptionType;
  public paymentMethods: PaymentMethod[];
  public defaultCardPaymentMethod: PaymentMethod;
  public payments: Payment[];
  public paymentPaypal: Payment[];
  // pagination
  public currentPage: number = 1;
  public itemsPerPage: number = 20;
  public itemsCount: number = 0;
  public pagesCount: number = 0;
  public userSubscriptionStatus: any = UserSubscriptionStatus;
  public isMobile: boolean;
  public paypalActions: IDropdownListItem[];
  public stripeErrors: any;
  public companyInfo: any;
  private _stripe: any;
  private _paypalSdk: any = null;
  private _paypalSession: any = null;
  private _paypalCardFields: any = null;
  public isPayPalProvider: boolean = false;
  public paypalSetupToken: string;
  public paypalFieldsReady: boolean = false;


  constructor(
    private _route: ActivatedRoute,
    private _workspaceService: WorkspaceService,
    private _store: Store<fromStore.DbStoreState>,
    private _dialogService: DialogService,
    private _requester: RequesterService,
    private _searchByPropertyPipe: SearchByPropertyPipe,
    private _languageService: LanguageService
  ) {
  }

  ngOnInit() {
    if (window.innerWidth < 991) {
      this.isMobile = true;
    }

    this.payments = this._route.snapshot.data['payments'];
    if (this.payments) {
      this.payments = this.payments.filter((payment) => payment.paymentStatus !== 'requires_source_action');
      this.paymentPaypal = this.payments.filter((payment) => payment.paymentStatus !== 'requires_source_action' && !payment.cardType && payment.paymentType === 'paypal_recurring');
      if (this.paymentPaypal) {
        this.paypalActions = [
          {
            label: 'Reauthenticate',
            action: () => {
             this.reauthenticate();
            }
          }
        ];
      }
      this._getCompanyInfo();

    }
    this.userSubscription = this._route.snapshot.data['userSubscription'];
    this._getUserSubscription();
    this._getPaymentMethods();
  }

  private _getUserSubscription(): void {
    this._store.select(fromStore.getUserLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => this._store.select(fromStore.getUserSubscription))
      )
      .subscribe((userSubscription: UserSubscription) => {
        this.userSubscription = userSubscription;
      });
  }

  public reauthenticate(): void {
    this.loading = true;
    this._workspaceService.changePaypalAccount('paypal')
    .pipe(
      filter((response: DbResponse): boolean => !!response),
      first())
      .subscribe((response) => {
        if (response.success) {
          if ( response.data.approval_link ) {
            localStorage.setItem('dbPaypalAccount', '1');
            window.location.href = response.data.approval_link;
          }
        }
        else {
          this.stripeErrors = response.serverErrors.message;
        }
        this.loading = false;

      });
  }

  public onActivePaymentMethodChange($event): void {
    if ( $event && $event.paymentMethod && $event.paymentMethod.active && $event.type !== 'changeFromPayPal'  && !(this.userSubscription.type === UserSubscriptionType.PREMIUM || this.userSubscription.type === UserSubscriptionType.ONE_PRODUCT || this.userSubscription.type === UserSubscriptionType.FREE)) {
      return;
    }
    const paymentMethodId: number = $event.paymentMethod.id;
    const paymentMethod = <PaymentMethod[]>this._searchByPropertyPipe.transform(this.paymentMethods, {'id': paymentMethodId});

    this._dialogService
      .addDialog(ChangePaymentMethodComponent, {
        paymentMethod: paymentMethod[0],
        changeEvent: $event && $event.type
      })
      .subscribe((isConfirmed: boolean) => {
        if ( isConfirmed ) {
          this._store.dispatch(new fromStore.LoadUserPaymentMethods());
          if ($event && $event.type === 'changeFromPayPal') {
            this._requester.clearCache();
            this._store.dispatch(new fromStore.UpdateUserSubscription());
            this._store.dispatch(new fromStore.LoadUser());
          }
        }
      });
  }

  private _getPaymentMethods(): void {
    this.loading = true;
    let paymentMethods = null;
    this._store.select(fromStore.getUserPaymentMethodsLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => this._store.select(fromStore.getUserPaymentMethods))
      )
      .subscribe(data => {
        if (data && !TypeUtils.isNull(data)) {
          paymentMethods = Utils.sort(data, (a: Product, b: Product): number => {
            return a.active === b.active ? 0 : (b.active && !a.active ? 1 : -1);
          });
          this.paymentMethods = paymentMethods;
          this.defaultCardPaymentMethod = paymentMethods.find(paymentMethod => paymentMethod.active) || paymentMethods[0];
        }
        this.loading = false;
      });
  }

  public async addPaymentMethod(): Promise<void> {
    try {
      this.loadingStripe = true;
      this.stripeErrors = null;

      const provider = this.companyInfo?.payment_provider?.provider;
      if (provider === 'paypal') {
        await this._initPayPalPaymentMethod();
      } else {
        await this._initStripePaymentMethod();
      }
    } catch (error) {
      this.loadingStripe = false;
      this.stripeErrors = error.message || 'Failed to initialize payment form.';
    }
  }

  private async _initPayPalPaymentMethod(): Promise<void> {
    await this._initPayPal();
    const clientId = await this.fetchPayPalClientId();
    await this._initPayPalCheckout(clientId);
    this.loadingStripe = false;
    const dialogRef = this._dialogService
      .addDialog(AddPaymentMethodComponent, {
        userSubscription: this.userSubscription,
        isPayPalProvider: true,
        confirmPayPalPayment: () => this.confirmPayPalPayment()
      });

    setTimeout(() => {
      this.renderPayPalFields();
    }, 500);

    dialogRef.subscribe((isConfirmed: boolean) => {
      if (isConfirmed) {
        this._store.dispatch(new fromStore.LoadUserPaymentMethods());
      }
    });
  }

  private async _initStripePaymentMethod(): Promise<void> {
    const clientSecret = await this.fetchClientSecret();
    await this._initStripe();
    await this._initCheckout(clientSecret);

    this.loadingStripe = false;
    this._dialogService
      .addDialog(AddPaymentMethodComponent, {
        userSubscription: this.userSubscription,
        checkout: this.checkoutElement,
        stripe: this._stripe
      })
      .subscribe((isConfirmed: boolean) => {
        if (isConfirmed) {
          this._store.dispatch(new fromStore.LoadUserPaymentMethods());
        }
      });
  }

  private _getCompanyInfo(): void {
    this._store.select(fromStore.getCompanyInfoLoaded)
        .pipe(
            filter((loaded: boolean) => loaded),
            switchMap(() => this._store.select(fromStore.getCompanyInfo)),
            first()
        )
        .subscribe((companyInfo: any) => {
          this.companyInfo = companyInfo;
        });
  }

  private async _initStripe(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      if (window['Stripe']) {
        const stripeConfig: any = {};

        // Support both new payment_provider and old stripe formats
        // New format: companyInfo.payment_provider.account_id (when provider is 'stripe_connect')
        // Old format: companyInfo.stripe.account_id (backward compatibility)
        let stripeAccountId = null;
        if (this.companyInfo?.payment_provider?.provider === 'stripe_connect' && this.companyInfo?.payment_provider?.account_id) {
          stripeAccountId = this.companyInfo.payment_provider.account_id;
        } else if (this.companyInfo?.stripe?.account_id) {
          stripeAccountId = this.companyInfo.stripe.account_id;
        }

        if (stripeAccountId) {
          stripeConfig.stripeAccount = stripeAccountId;
        }

        // Set locale from language service
        const currentLanguage = this._languageService.getCurrentLanguage();
        if (currentLanguage) {
          stripeConfig.locale = currentLanguage;
        }

        this._stripe = window['Stripe'](Config.stripeKey, stripeConfig);
        resolve(true);
      }
      else {
        reject(false);
      }
    });
  }

  private fetchPayPalClientId = (): Promise<string> => {
    return new Promise<string>((resolve, reject) => {
      const clientId = this.companyInfo?.payment_provider?.account_id;

      if (clientId) {
        resolve(clientId);
      } else {
        reject(new Error('PayPal client ID not found in payment provider configuration'));
      }
    });
  }

  private fetchPayPalSetupToken = (): Promise<string> => {
    return new Promise<string>((resolve, reject) => {

      this._workspaceService.addPaymentMethod()
        .pipe(
          filter(response => !!response),
          first()
        )
        .subscribe({
          next: (response) => {
            const body = response?.response?.body;
            const setupToken = body?.setup_intent?.setup_token ||
                             body?.id ||
                             body?.setup_token;

            if (setupToken) {
              this.paypalSetupToken = setupToken;
              resolve(setupToken);
            } else {
              reject(new Error('No setup token received from backend'));
            }
          },
          error: (err) => {
            reject(err);
          }
        });
    });
  }

  public confirmPayPalPayment = async (): Promise<{ success: boolean; error?: string }> => {
    try {
      if (!this.paypalFieldsReady) {
        return {
          success: false,
          error: 'Payment fields are still loading. Please wait a moment and try again.'
        };
      }

      if (!this._paypalSession || typeof this._paypalSession.submit !== 'function') {
        return {
          success: false,
          error: 'Payment system not initialized. Please try again.'
        };
      }
      const setupToken = await this.fetchPayPalSetupToken();
      const { state, data } = await this._paypalSession.submit(setupToken);
      // Debug 3DS behavior for sandbox “expected-to-fail” cards.
      // Avoid logging full tokens/PII; log only booleans/keys and any 3DS indicator fields we can find.
      const dataKeys = data ? Object.keys(data) : [];
      const threeDsIndicators = {
        verification_status: data?.verification_status ?? data?.verificationStatus ?? null,
        liability_shift: data?.liability_shift
          ?? data?.authentication_result?.liability_shift
          ?? data?.three_d_secure?.liability_shift
          ?? null,
      };

      console.log('[PayPal CardFields save] submit result', {
        state,
        vaultSetupTokenPresent: Boolean(data?.vaultSetupToken),
        dataKeys,
        threeDsIndicators,
      });
      const liabilityShift = threeDsIndicators?.liability_shift
          ? String(threeDsIndicators.liability_shift).toUpperCase()
          : null;
      // Optional safety net: if Card Fields returns `succeeded` but the payload clearly indicates
      // a 3DS failure (for some sandbox expected-to-fail test cards), don't store the vault token.
      if (state === 'succeeded') {

        // Hard rejection for explicit authentication failure
        if (liabilityShift === 'NO') {
          NotifierComponent.notify(new Notification(
            '3D Secure authentication failed. Please use another card.',
            NotificationType.DANGER
          ));

          return {
            success: false,
            error: '3D Secure authentication failed',
          };
        }

        // Soft rejection for uncertain/unavailable authentication - allow retry
        if (liabilityShift === 'UNKNOWN') {
          NotifierComponent.notify(new Notification(
            '3D Secure authentication unavailable. Please try again or use another card.',
            NotificationType.DANGER
          ));

          return {
            success: false,
            error: '3D Secure authentication unavailable',
          };
        }
      }
      switch (state) {
        case 'succeeded':
          const storeResponse = await this._workspaceService
            .storePaymentMethod({ vaultSetupToken: data.vaultSetupToken })
            .pipe(
              filter(res => !!res),
              first()
            )
            .toPromise();

          if (storeResponse && storeResponse.success) {
            return { success: true };
          } else {
            const errorMessage = storeResponse?.serverErrors?.message || 'Failed to save payment method. Please try again.';
            NotifierComponent.notify(new Notification(
              errorMessage,
              NotificationType.DANGER
            ));
            return {
              success: false,
              error: errorMessage
            };
          }

        case 'canceled':
          NotifierComponent.notify(new Notification(
            'Payment was canceled.',
            NotificationType.DANGER
          ));
          return {
            success: false,
            error: 'Payment canceled. Please try again.'
          };

        case 'failed':
          // Check if failure was due to 3DS authentication
          if (liabilityShift === 'NO') {
            NotifierComponent.notify(new Notification(
              '3D Secure authentication failed. Please use another card.',
              NotificationType.DANGER
            ));
            return {
              success: false,
              error: '3D Secure authentication failed'
            };
          }

          if (liabilityShift === 'UNKNOWN') {
            NotifierComponent.notify(new Notification(
              '3D Secure authentication unavailable. Please try again or use another card.',
              NotificationType.DANGER
            ));
            return {
              success: false,
              error: '3D Secure authentication unavailable'
            };
          }

          // Generic failure
          NotifierComponent.notify(new Notification(
            data.message || 'Failed to save payment method. Please try again.',
            NotificationType.DANGER
          ));
          return {
            success: false,
            error: data.message || 'Payment failed. Please try again.'
          };

        case 'requires_action':
        case 'payer_action_required':
          NotifierComponent.notify(new Notification(
            'Additional verification is required to complete 3D Secure. Please follow the prompt and try again.',
            NotificationType.DANGER
          ));
          return {
            success: false,
            error: '3D Secure verification requires additional action.'
          };

        default:
          return {
            success: false,
            error: 'Unexpected payment state. Please try again.'
          };
      }

    } catch (error) {
      return {
        success: false,
        error: error.message || 'Failed to save payment method. Please try again.'
      };
    }
  }

  private fetchClientSecret = (): Promise<string> => {
    return new Promise<string>((resolve, reject) => {

      // Call backend to create setup token
      this._workspaceService.addPaymentMethod()
          .pipe(
              filter(response => !!response),
              first()
          )
          .subscribe({
            next: (response) => {
              const body = response?.response?.body;
                // Stripe flow: Extract client secret
                if (body?.setup_intent?.client_secret) {
                  this.isPayPalProvider = false;
                  resolve(body.setup_intent.client_secret);
                } else {
                  reject(new Error('Invalid Stripe response data'));
                }
            },
            error: (err) => {
              reject(err);
            }
          });
    });
  }

  public async _initCheckout(clientSecret: string) {
    try {
      if (!clientSecret) {
        throw new Error('Failed to get client secret from server');
      }
      this.checkoutElement = this._stripe.elements({
        clientSecret: clientSecret,
        appearance: {
          theme: 'stripe'
        }
      });
    } catch (error) {
      throw error;
    }
  }

  public deletePaymentMethod($event, additionalPayments?: boolean): void {
    if ( $event && $event.paymentMethod && $event.paymentMethod.active && additionalPayments) {
      return;
    }
    const paymentMethodId: number = $event.paymentMethod.id;
    const paymentMethod = <PaymentMethod[]>this._searchByPropertyPipe.transform(this.paymentMethods, {'id': paymentMethodId});

    this._dialogService
      .addDialog(RemovePaymentMethodComponent, {
        paymentMethod: paymentMethod[0],
        userSubscription: this.userSubscription
      })
      .subscribe((isConfirmed: boolean) => {
        if ( isConfirmed ) {
          this._store.dispatch(new fromStore.LoadUserPaymentMethods());
        }
      });
  }

  private async _initPayPal(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      // Check if SDK already loaded
      if (window['paypal']) {
        resolve(true);
        return;
      }

      const script = document.createElement('script');
      script.src = Config.paypalIsProduction
        ? 'https://www.paypal.com/web-sdk/v6/core'
        : 'https://www.sandbox.paypal.com/web-sdk/v6/core';
      script.async = true;

      script.onload = () => {
        resolve(true);
      };

      script.onerror = () => {
        this.stripeErrors = 'Failed to load PayPal payment system.';
        reject(false);
      };

      document.head.appendChild(script);
    });
  }

  public async _initPayPalCheckout(clientId: string): Promise<void> {
    if (!window['paypal']) {
      throw new Error('PayPal SDK not loaded');
    }

    if (typeof window['paypal'].createInstance !== 'function') {
      throw new Error('PayPal v6 SDK createInstance not available');
    }

    try {
      this._paypalSdk = await window['paypal'].createInstance({
        clientId: clientId,
        components: ["card-fields"]
      });
      this._paypalSession = this._paypalSdk.createCardFieldsSavePaymentSession();

      if (!this._paypalSession) {
        throw new Error('Failed to create CardFieldsSavePaymentSession');
      }

    } catch (error) {
      throw error;
    }
  }

  public async renderPayPalFields(): Promise<void> {
    try {
      if (!this._paypalSession) {
        throw new Error('PayPal session not created');
      }
      const fieldStyle = {
        input: {
          fontSize: '14px',
          fontFamily: 'inherit',
          color: '#000000',
          height: '44px',
          padding: '12px 16px',
          borderRadius: '8px',
          border: '1px solid rgba(118, 118, 128, 0.16)',
          background: '#FFFFFF',
          transition: 'border-color 0.2s ease',
          outline: 'none'
        },
        'input.focus': {
          border: '1px solid #000000',
          outline: 'none'
        },
        '.invalid': {
          border: '1px solid #f44040',
        },
        '.invalid.focus': {
          border: '1px solid #f44040',
        }
      };

      const numberField = this._paypalSession.createCardFieldsComponent({
        type: 'number',
        selector: '#card-number',
        placeholder: TextUtils.getText('text_cardNumber'),
        style: fieldStyle
      });

      const expiryField = this._paypalSession.createCardFieldsComponent({
        type: 'expiry',
        selector: '#card-expiry',
        placeholder: 'MM/YYYY',
        style: fieldStyle
      });

      const cvvField = this._paypalSession.createCardFieldsComponent({
        type: 'cvv',
        selector: '#card-cvv',
        placeholder: 'CID/CVV',
        style: fieldStyle
      });

      document.querySelector("#card-number").appendChild(numberField);
      document.querySelector("#card-expiry").appendChild(expiryField);
      document.querySelector("#card-cvv").appendChild(cvvField);

      this.paypalFieldsReady = true;


    } catch (error) {
      this.stripeErrors = 'Failed to render PayPal payment fields.';
    }
  }

}
